export default {
  'entities.aiModel.fields.created_dt': 'Вақти эҷод',
  'entities.aiModel.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.aiModel.fields.id': 'Рақам / ID',
  'entities.aiModel.fields.model_path': 'Масири модел',
  'entities.aiModel.fields.name': 'Ном',
  'entities.aiModel.fields.parent': 'Волидайнӣ',
  'entities.aiModel.fields.parent_id': 'Рақами волидайнӣ',
  'entities.aiModel.fields.updated_dt': 'Вақти навсозӣ',
  'entities.aiModel.title': 'Модели ИИ',
  'entities.application.fields.application': 'Барнома',
  'entities.application.fields.application_id': 'Рақами барнома',
  'entities.application.fields.created_dt': 'Вақти эҷод',
  'entities.application.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.application.fields.details': 'Тафсилот (JSON)',
  'entities.application.fields.id': 'Рақам / ID',
  'entities.application.fields.updated_dt': 'Вақти навсозӣ',
  'entities.application.title': 'Барнома',
  'entities.applicationToken.fields.access_token': 'Нишонаи дастрасӣ',
  'entities.applicationToken.fields.access_token_expired_time': 'Хотимаи мӯҳлати токени дастрасӣ',
  'entities.applicationToken.fields.created_dt': 'Вақти эҷод',
  'entities.applicationToken.fields.id': 'Рақам / ID',
  'entities.applicationToken.fields.refresh_token': 'Нишонаи навкунӣ',
  'entities.applicationToken.fields.refresh_token_expired_time': 'Хотимаи мӯҳлати нишонаи навкунӣ',
  'entities.applicationToken.fields.user_id': 'Рақами корбар',
  'entities.applicationToken.title': 'Нишонаи барномавӣ',
  'entities.authLogin.fields.email': 'Почтаи электронӣ',
  'entities.authLogin.fields.password': 'Парол',
  'entities.authLogin.title': 'Даромад',
  'entities.authRegister.fields.email': 'Почтаи электронӣ',
  'entities.authRegister.fields.name': 'Ном',
  'entities.authRegister.fields.parent_id': 'Рақами волидайнӣ',
  'entities.authRegister.fields.password': 'Парол',
  'entities.authRegister.title': 'Сабти ном',
  'entities.authResponse.fields.access_token': 'Нишонаи дастрасӣ',
  'entities.authResponse.fields.refresh_token': 'Нишонаи навкунӣ',
  'entities.authResponse.fields.token_type': 'Навъи токен',
  'entities.authResponse.fields.user': 'Корбар',
  'entities.authResponse.title': 'Auth Response',
  'entities.brokerEvent.fields.created_dt': 'Вақти эҷод',
  'entities.brokerEvent.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.brokerEvent.fields.id': 'Рақам / ID',
  'entities.brokerEvent.fields.name': 'Ном',
  'entities.brokerEvent.fields.slug': 'Нишона (slug)',
  'entities.brokerEvent.fields.updated_dt': 'Вақти навсозӣ',
  'entities.brokerEvent.title': 'Рӯйдади брокер',
  'entities.common.fields.created_dt': 'Вақти эҷод',
  'entities.common.fields.default': 'Пешфарз',
  'entities.common.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.common.fields.detail_scheduler_id': 'Рақами тафсилоти ҷадвалгузор',
  'entities.common.fields.details': 'Тафсилот (JSON)',
  'entities.common.fields.email': 'Почтаи электронӣ',
  'entities.common.fields.id': 'Рақам / ID',
  'entities.common.fields.login': 'Логин (почта)',
  'entities.common.fields.name': 'Ном',
  'entities.common.fields.npp': 'Рақами тартиб',
  'entities.common.fields.organization_id': 'Рақами субъект',
  'entities.common.fields.parent_id': 'Рақами волидайнӣ',
  'entities.common.fields.password': 'Парол',
  'entities.common.fields.permission_id': 'Рақами иҷозат',
  'entities.common.fields.pipeline_id': 'Рақами нақб',
  'entities.common.fields.position_id': 'Рақами вазифа',
  'entities.common.fields.schema_pipeline': 'Схемаи нақб',
  'entities.common.fields.service_id': 'Рақами хизматрасонӣ',
  'entities.common.fields.slug': 'Нишона (slug)',
  'entities.common.fields.status': 'Ҳолат',
  'entities.common.fields.status_id': 'Рақами ҳолат',
  'entities.common.fields.subject_id': 'Рақами субъект',
  'entities.common.fields.token_type': 'Навъи токен',
  'entities.common.fields.type': 'Намуд',
  'entities.common.fields.updated_dt': 'Вақти навсозӣ',
  'entities.common.fields.user': 'Корбар',
  'entities.common.fields.user_id': 'Рақами корбар',
  'entities.common.fields.version_id': 'Рақами насх',
  'entities.communication.fields.create_user': 'Корбари сохтордиҳанда',
  'entities.communication.fields.create_user_id': 'Рақами корбари созмонкунанда',
  'entities.communication.fields.created_dt': 'Вақти эҷод',
  'entities.communication.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.communication.fields.id': 'Рақам / ID',
  'entities.communication.fields.name': 'Ном',
  'entities.communication.fields.slug': 'Нишона (slug)',
  'entities.communication.fields.subject_communication': 'Субъекти коммуникатсия',
  'entities.communication.fields.subject_communication_id': 'Рақами субъекти коммуникатсия',
  'entities.communication.fields.updated_dt': 'Вақти навсозӣ',
  'entities.communication.title': 'Коммуникатсия',
  'entities.communicationDetail.fields.communication': 'Коммуникатсия',
  'entities.communicationDetail.fields.communication_id': 'Рақами коммуникатсия',
  'entities.communicationDetail.fields.created_dt': 'Вақти эҷод',
  'entities.communicationDetail.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.communicationDetail.fields.folder': 'Ҷӯрчубӣ',
  'entities.communicationDetail.fields.folder_id': 'Рақами ҷӯрчубӣ',
  'entities.communicationDetail.fields.id': 'Рақам / ID',
  'entities.communicationDetail.fields.updated_dt': 'Вақти навсозӣ',
  'entities.communicationDetail.fields.view': 'Намоиш',
  'entities.communicationDetail.title': 'Тафсилоти коммуникатсия',
  'entities.communicationFolder.fields.created_dt': 'Вақти эҷод',
  'entities.communicationFolder.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.communicationFolder.fields.id': 'Рақам / ID',
  'entities.communicationFolder.fields.name': 'Ном',
  'entities.communicationFolder.fields.org_structure': 'Сохтори созмонӣ',
  'entities.communicationFolder.fields.org_structure_id': 'Рақами сохтор',
  'entities.communicationFolder.fields.organization': 'Ташкилот',
  'entities.communicationFolder.fields.organization_id': 'Рақами субъект',
  'entities.communicationFolder.fields.parent': 'Волидайнӣ',
  'entities.communicationFolder.fields.parent_id': 'Рақами волидайнӣ',
  'entities.communicationFolder.fields.slug': 'Нишона (slug)',
  'entities.communicationFolder.fields.updated_dt': 'Вақти навсозӣ',
  'entities.communicationFolder.title': 'Ҷӯрчуби коммуникатсия',
  'entities.communicationHistory.fields.communication': 'Коммуникатсия',
  'entities.communicationHistory.fields.created_dt': 'Вақти эҷод',
  'entities.communicationHistory.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.communicationHistory.fields.history_running_pipelines': 'Таърихи иҷрои нақб',
  'entities.communicationHistory.fields.id': 'Рақам / ID',
  'entities.communicationHistory.fields.updated_dt': 'Вақти навсозӣ',
  'entities.communicationHistory.fields.version': 'Насх',
  'entities.communicationHistory.fields.version_id': 'Рақами насх',
  'entities.communicationHistory.title': 'Таърихи коммуникатсия',
  'entities.communicationPermission.fields.communication': 'Коммуникатсия',
  'entities.communicationPermission.fields.created_dt': 'Вақти эҷод',
  'entities.communicationPermission.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.communicationPermission.fields.id': 'Рақам / ID',
  'entities.communicationPermission.fields.org_structures': 'Сохторҳо',
  'entities.communicationPermission.fields.org_structures_id': 'Рақами сохтор',
  'entities.communicationPermission.fields.permission': 'Иҷозат',
  'entities.communicationPermission.fields.permission_id': 'Рақами иҷозат',
  'entities.communicationPermission.fields.position': 'Вазифа',
  'entities.communicationPermission.fields.position_id': 'Рақами вазифа',
  'entities.communicationPermission.fields.updated_dt': 'Вақти навсозӣ',
  'entities.communicationPermission.fields.view': 'Намоиш',
  'entities.communicationPermission.fields.view_id': 'Рақами намоиш',
  'entities.communicationPermission.title': 'Иҷозоти коммуникатсия',
  'entities.communicationStrategy.fields.communication': 'Коммуникатсия',
  'entities.communicationStrategy.fields.created_dt': 'Вақти эҷод',
  'entities.communicationStrategy.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.communicationStrategy.fields.id': 'Рақам / ID',
  'entities.communicationStrategy.fields.provider_context_classification': 'Синфбандии контексти таъминкунанда',
  'entities.communicationStrategy.fields.provider_context_classification_id': 'Рақами синфбандӣ',
  'entities.communicationStrategy.fields.updated_dt': 'Вақти навсозӣ',
  'entities.communicationStrategy.fields.version': 'Насх',
  'entities.communicationStrategy.fields.version_id': 'Рақами насх',
  'entities.communicationStrategy.title': 'Стратегияи коммуникатсия',
  'entities.communicationSubject.fields.classification_id': 'Рақами синфбандӣ',
  'entities.communicationSubject.fields.created_dt': 'Вақти эҷод',
  'entities.communicationSubject.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.communicationSubject.fields.id': 'Рақам / ID',
  'entities.communicationSubject.fields.name': 'Ном',
  'entities.communicationSubject.fields.organization': 'Ташкилот',
  'entities.communicationSubject.fields.organization_id': 'Рақами субъект',
  'entities.communicationSubject.fields.slug': 'Нишона (slug)',
  'entities.communicationSubject.fields.type': 'Намуд',
  'entities.communicationSubject.fields.type_id': 'Рақами намуд',
  'entities.communicationSubject.fields.updated_dt': 'Вақти навсозӣ',
  'entities.communicationSubject.title': 'Субъекти коммуникатсия',
  'entities.communicationVersion.fields.communication': 'Коммуникатсия',
  'entities.communicationVersion.fields.create_user_id': 'Рақами корбари созмонкунанда',
  'entities.communicationVersion.fields.created_dt': 'Вақти эҷод',
  'entities.communicationVersion.fields.default': 'Пешфарз',
  'entities.communicationVersion.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.communicationVersion.fields.id': 'Рақам / ID',
  'entities.communicationVersion.fields.name': 'Ном',
  'entities.communicationVersion.fields.npp': 'Рақами тартиб',
  'entities.communicationVersion.fields.pipeline': 'Нақб',
  'entities.communicationVersion.fields.pipeline_id': 'Рақами нақб',
  'entities.communicationVersion.fields.updated_dt': 'Вақти навсозӣ',
  'entities.communicationVersion.title': 'Насхи коммуникатсия',
  'entities.communicationView.fields.created_dt': 'Вақти эҷод',
  'entities.communicationView.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.communicationView.fields.id': 'Рақам / ID',
  'entities.communicationView.fields.name': 'Ном',
  'entities.communicationView.fields.organization': 'Ташкилот',
  'entities.communicationView.fields.organization_id': 'Рақами субъект',
  'entities.communicationView.fields.slug': 'Нишона (slug)',
  'entities.communicationView.fields.updated_dt': 'Вақти навсозӣ',
  'entities.communicationView.title': 'Намоиши коммуникатсия',
  'entities.contextClassifier.fields.created_dt': 'Вақти эҷод',
  'entities.contextClassifier.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.contextClassifier.fields.id': 'Рақам / ID',
  'entities.contextClassifier.fields.name': 'Ном',
  'entities.contextClassifier.fields.organization': 'Ташкилот',
  'entities.contextClassifier.fields.organization_id': 'Рақами субъект',
  'entities.contextClassifier.fields.slug': 'Нишона (slug)',
  'entities.contextClassifier.fields.updated_dt': 'Вақти навсозӣ',
  'entities.contextClassifier.title': 'Синфкунандаи контекст',
  'entities.contextData.fields.created_dt': 'Вақти эҷод',
  'entities.contextData.fields.data_key': 'Калиди маълумот',
  'entities.contextData.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.contextData.fields.id': 'Рақам / ID',
  'entities.contextData.fields.name': 'Ном',
  'entities.contextData.fields.source': 'Сарчашма',
  'entities.contextData.fields.storage': 'Захира',
  'entities.contextData.fields.storage_id': 'Рақами захира',
  'entities.contextData.fields.updated_dt': 'Вақти навсозӣ',
  'entities.contextData.fields.version': 'Насх',
  'entities.contextData.fields.version_id': 'Рақами насх',
  'entities.contextData.title': 'Маълумоти контекст',
  'entities.contextPipeline.fields.created_dt': 'Вақти эҷод',
  'entities.contextPipeline.fields.data': 'Маълумот',
  'entities.contextPipeline.fields.data_id': 'Рақами маълумот',
  'entities.contextPipeline.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.contextPipeline.fields.id': 'Рақам / ID',
  'entities.contextPipeline.fields.name': 'Ном',
  'entities.contextPipeline.fields.pipeline': 'Нақб',
  'entities.contextPipeline.fields.pipeline_id': 'Рақами нақб',
  'entities.contextPipeline.fields.provider': 'Таъминкунанда',
  'entities.contextPipeline.fields.storage': 'Захира',
  'entities.contextPipeline.fields.storage_id': 'Рақами захира',
  'entities.contextPipeline.fields.updated_dt': 'Вақти навсозӣ',
  'entities.contextPipeline.title': 'Нақбаи контекст',
  'entities.contextStorage.fields.created_dt': 'Вақти эҷод',
  'entities.contextStorage.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.contextStorage.fields.id': 'Рақам / ID',
  'entities.contextStorage.fields.name': 'Ном',
  'entities.contextStorage.fields.organization': 'Ташкилот',
  'entities.contextStorage.fields.organization_id': 'Рақами субъект',
  'entities.contextStorage.fields.provider': 'Таъминкунанда',
  'entities.contextStorage.fields.updated_dt': 'Вақти навсозӣ',
  'entities.contextStorage.fields.version': 'Насх',
  'entities.contextStorage.fields.version_id': 'Рақами насх',
  'entities.contextStorage.title': 'Захираи контекст',
  'entities.dataPipeline.fields.created_dt': 'Вақти эҷод',
  'entities.dataPipeline.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.dataPipeline.fields.id': 'Рақам / ID',
  'entities.dataPipeline.fields.name': 'Ном',
  'entities.dataPipeline.fields.organization': 'Ташкилот',
  'entities.dataPipeline.fields.organization_id': 'Рақами субъект',
  'entities.dataPipeline.fields.type_param_service_id': 'Рақами намуднамои параметр',
  'entities.dataPipeline.fields.updated_dt': 'Вақти навсозӣ',
  'entities.dataPipeline.title': 'Нақби маълумот',
  'entities.dataPipelineDetail.fields.created_dt': 'Вақти эҷод',
  'entities.dataPipelineDetail.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.dataPipelineDetail.fields.environment': 'Муҳит',
  'entities.dataPipelineDetail.fields.id': 'Рақам / ID',
  'entities.dataPipelineDetail.fields.input_params': 'Параметрҳои вуруд',
  'entities.dataPipelineDetail.fields.output_params': 'Параметрҳои берун',
  'entities.dataPipelineDetail.fields.test_pipeline': 'Нақби санҷиш',
  'entities.dataPipelineDetail.fields.updated_dt': 'Вақти навсозӣ',
  'entities.dataPipelineDetail.title': 'Тафсилоти нақби маълумот',
  'entities.dependentVersionService.fields.created_dt': 'Вақти эҷод',
  'entities.dependentVersionService.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.dependentVersionService.fields.dependent': 'Вобастагӣ',
  'entities.dependentVersionService.fields.id': 'Рақам / ID',
  'entities.dependentVersionService.fields.updated_dt': 'Вақти навсозӣ',
  'entities.dependentVersionService.fields.version': 'Насх',
  'entities.dependentVersionService.title': 'Вобастагии насх',
  'entities.detailScheduler.fields.created_dt': 'Вақти эҷод',
  'entities.detailScheduler.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.detailScheduler.fields.id': 'Рақам / ID',
  'entities.detailScheduler.fields.run_dt': 'Вақти оғоз',
  'entities.detailScheduler.fields.scheduler': 'Ҷадвалгузор',
  'entities.detailScheduler.fields.updated_dt': 'Вақти навсозӣ',
  'entities.detailScheduler.title': 'Элементи иҷрои ҷадвал',
  'entities.division.fields.created_dt': 'Вақти эҷод',
  'entities.division.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.division.fields.details': 'Тафсилот (JSON)',
  'entities.division.fields.division': 'Қисмот',
  'entities.division.fields.division_id': 'Рақами қисмат',
  'entities.division.fields.id': 'Рақам / ID',
  'entities.division.fields.updated_dt': 'Вақти навсозӣ',
  'entities.division.title': 'Қисмот',
  'entities.groupContextClassifier.fields.classifier': 'Синфкунанда',
  'entities.groupContextClassifier.fields.classifier_id': 'Рақами синфкунанда',
  'entities.groupContextClassifier.fields.created_dt': 'Вақти эҷод',
  'entities.groupContextClassifier.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.groupContextClassifier.fields.id': 'Рақам / ID',
  'entities.groupContextClassifier.fields.parent_classifier': 'Синфкунандаи волидайнӣ',
  'entities.groupContextClassifier.fields.parent_classifier_id': 'Рақами синфкунандаи волидайнӣ',
  'entities.groupContextClassifier.fields.updated_dt': 'Вақти навсозӣ',
  'entities.groupContextClassifier.title': 'Гӯруҳи синфкунандаҳо',
  'entities.historyRunningPipeline.fields.created_dt': 'Вақти эҷод',
  'entities.historyRunningPipeline.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.historyRunningPipeline.fields.environment': 'Муҳит',
  'entities.historyRunningPipeline.fields.exit_dt': 'Вақти анҷом',
  'entities.historyRunningPipeline.fields.id': 'Рақам / ID',
  'entities.historyRunningPipeline.fields.input_params': 'Параметрҳои вуруд',
  'entities.historyRunningPipeline.fields.output_params': 'Параметрҳои берун',
  'entities.historyRunningPipeline.fields.pipeline': 'Нақб',
  'entities.historyRunningPipeline.fields.run_dt': 'Вақти оғоз',
  'entities.historyRunningPipeline.fields.schema': 'Схемаи нақб',
  'entities.historyRunningPipeline.fields.schema_id': 'Рақами схема',
  'entities.historyRunningPipeline.fields.updated_dt': 'Вақти навсозӣ',
  'entities.historyRunningPipeline.fields.user_id': 'Рақами корбар',
  'entities.historyRunningPipeline.title': 'Таърихи иҷрои нақб',
  'entities.historyRunningStreamPipeline.fields.created_dt': 'Вақти эҷод',
  'entities.historyRunningStreamPipeline.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.historyRunningStreamPipeline.fields.exit_dt': 'Вақти анҷом',
  'entities.historyRunningStreamPipeline.fields.id': 'Рақам / ID',
  'entities.historyRunningStreamPipeline.fields.run_dt': 'Вақти оғоз',
  'entities.historyRunningStreamPipeline.fields.schema': 'Схемаи нақб',
  'entities.historyRunningStreamPipeline.fields.schema_id': 'Рақами схема',
  'entities.historyRunningStreamPipeline.fields.stream_params': 'Параметрҳои ҷараён',
  'entities.historyRunningStreamPipeline.fields.updated_dt': 'Вақти навсозӣ',
  'entities.historyRunningStreamPipeline.title': 'Таърихи услуби ҷараён',
  'entities.individual.fields.created_dt': 'Вақти эҷод',
  'entities.individual.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.individual.fields.details': 'Тафсилот (JSON)',
  'entities.individual.fields.id': 'Рақам / ID',
  'entities.individual.fields.subject': 'Субъект',
  'entities.individual.fields.subject_id': 'Рақами субъект',
  'entities.individual.fields.updated_dt': 'Вақти навсозӣ',
  'entities.individual.title': 'Шахси воқеӣ',
  'entities.jwtToken.fields.access_token': 'Нишонаи дастрасӣ',
  'entities.jwtToken.fields.access_token_expired_time': 'Хотимаи мӯҳлати токени дастрасӣ',
  'entities.jwtToken.fields.created_dt': 'Вақти эҷод',
  'entities.jwtToken.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.jwtToken.fields.id': 'Рақам / ID',
  'entities.jwtToken.fields.refresh_token': 'Нишонаи навкунӣ',
  'entities.jwtToken.fields.refresh_token_expired_time': 'Хотимаи мӯҳлати нишонаи навкунӣ',
  'entities.jwtToken.fields.updated_dt': 'Вақти навсозӣ',
  'entities.jwtToken.fields.user_id': 'Рақами корбар',
  'entities.jwtToken.title': 'Сабти нишонаи JWT',
  'entities.organization.fields.created_dt': 'Вақти эҷод',
  'entities.organization.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.organization.fields.details': 'Тафсилот (JSON)',
  'entities.organization.fields.id': 'Рақам / ID',
  'entities.organization.fields.name': 'Ном',
  'entities.organization.fields.organization': 'Ташкилот',
  'entities.organization.fields.updated_dt': 'Вақти навсозӣ',
  'entities.organization.title': 'Ташкилот',
  'entities.organizationPosition.fields.created_dt': 'Вақти эҷод',
  'entities.organizationPosition.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.organizationPosition.fields.id': 'Рақам / ID',
  'entities.organizationPosition.fields.name': 'Ном',
  'entities.organizationPosition.fields.organization': 'Ташкилот',
  'entities.organizationPosition.fields.organization_id': 'Рақами субъект',
  'entities.organizationPosition.fields.slug': 'Нишона (slug)',
  'entities.organizationPosition.fields.updated_dt': 'Вақти навсозӣ',
  'entities.organizationPosition.title': 'Вазифа дар ташкилот',
  'entities.organizationStructure.fields.created_dt': 'Вақти эҷод',
  'entities.organizationStructure.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.organizationStructure.fields.id': 'Рақам / ID',
  'entities.organizationStructure.fields.name': 'Ном',
  'entities.organizationStructure.fields.organization': 'Ташкилот',
  'entities.organizationStructure.fields.organization_id': 'Рақами субъект',
  'entities.organizationStructure.fields.parent': 'Волидайнӣ',
  'entities.organizationStructure.fields.parent_id': 'Рақами волидайнӣ',
  'entities.organizationStructure.fields.position': 'Вазифа',
  'entities.organizationStructure.fields.position_id': 'Рақами вазифа',
  'entities.organizationStructure.fields.status': 'Ҳолат',
  'entities.organizationStructure.fields.subject': 'Субъект',
  'entities.organizationStructure.fields.subject_id': 'Рақами субъект',
  'entities.organizationStructure.fields.type': 'Намуд',
  'entities.organizationStructure.fields.updated_dt': 'Вақти навсозӣ',
  'entities.organizationStructure.title': 'Сохтори созмонӣ',
  'entities.organizationStructureInvite.fields.invite_id': 'Рақами даъват',
  'entities.organizationStructureInvite.fields.name': 'Ном',
  'entities.organizationStructureInvite.fields.organization_id': 'Рақами субъект',
  'entities.organizationStructureInvite.fields.position_id': 'Рақами вазифа',
  'entities.organizationStructureInvite.fields.subject_id': 'Рақами субъект',
  'entities.organizationStructureInvite.title': 'Даъват ба сохтор',
  'entities.organizationStructurePermission.fields.created_dt': 'Вақти эҷод',
  'entities.organizationStructurePermission.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.organizationStructurePermission.fields.id': 'Рақам / ID',
  'entities.organizationStructurePermission.fields.org_structure': 'Сохтори созмонӣ',
  'entities.organizationStructurePermission.fields.org_structure_id': 'Рақами сохтор',
  'entities.organizationStructurePermission.fields.organization': 'Ташкилот',
  'entities.organizationStructurePermission.fields.organization_id': 'Рақами субъект',
  'entities.organizationStructurePermission.fields.permission': 'Иҷозат',
  'entities.organizationStructurePermission.fields.permission_id': 'Рақами иҷозат',
  'entities.organizationStructurePermission.fields.subject_org_structure_id': 'Сохтори субъекти иҷозат',
  'entities.organizationStructurePermission.fields.updated_dt': 'Вақти навсозӣ',
  'entities.organizationStructurePermission.title': 'Дастрасӣ ба сохтор',
  'entities.permission.fields.created_dt': 'Вақти эҷод',
  'entities.permission.fields.id': 'Рақам / ID',
  'entities.permission.fields.name': 'Ном',
  'entities.permission.fields.slug': 'Нишона (slug)',
  'entities.permission.fields.updated_dt': 'Вақти навсозӣ',
  'entities.permission.title': 'Иҷозат',
  'entities.pipeline.fields.broker_event': 'Рӯйдади брокер',
  'entities.pipeline.fields.broker_event_id': 'Рӯйдади брокер (ID)',
  'entities.pipeline.fields.build_dt': 'Вақти ҷамъоварӣ',
  'entities.pipeline.fields.build_id': 'Рақами ҷамъоварӣ',
  'entities.pipeline.fields.created_dt': 'Вақти эҷод',
  'entities.pipeline.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.pipeline.fields.id': 'Рақам / ID',
  'entities.pipeline.fields.name': 'Ном',
  'entities.pipeline.fields.organization': 'Ташкилот',
  'entities.pipeline.fields.organization_id': 'Рақами субъект',
  'entities.pipeline.fields.run_dt': 'Вақти оғоз',
  'entities.pipeline.fields.run_id': 'Рақами иҷро',
  'entities.pipeline.fields.status': 'Ҳолат',
  'entities.pipeline.fields.updated_dt': 'Вақти навсозӣ',
  'entities.pipeline.title': 'Нақби коркард',
  'entities.providerContext.fields.created_dt': 'Вақти эҷод',
  'entities.providerContext.fields.data': 'Маълумот',
  'entities.providerContext.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.providerContext.fields.id': 'Рақам / ID',
  'entities.providerContext.fields.limit': 'Ҳудуд',
  'entities.providerContext.fields.name': 'Ном',
  'entities.providerContext.fields.organization': 'Ташкилот',
  'entities.providerContext.fields.organization_id': 'Рақами субъект',
  'entities.providerContext.fields.service': 'Хизматрасонӣ',
  'entities.providerContext.fields.service_id': 'Рақами хизматрасонӣ',
  'entities.providerContext.fields.slug': 'Нишона (slug)',
  'entities.providerContext.fields.type_provider': 'Намуди таъминкунанда',
  'entities.providerContext.fields.updated_dt': 'Вақти навсозӣ',
  'entities.providerContext.title': 'Контексти таъминкунанда',
  'entities.providerContextClassifier.fields.classifier': 'Синфкунанда',
  'entities.providerContextClassifier.fields.classifier_id': 'Рақами синфкунанда',
  'entities.providerContextClassifier.fields.created_dt': 'Вақти эҷод',
  'entities.providerContextClassifier.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.providerContextClassifier.fields.id': 'Рақам / ID',
  'entities.providerContextClassifier.fields.name': 'Ном',
  'entities.providerContextClassifier.fields.provider': 'Таъминкунанда',
  'entities.providerContextClassifier.fields.provider_id': 'Рақами таъминкунанда',
  'entities.providerContextClassifier.fields.storage': 'Захира',
  'entities.providerContextClassifier.fields.updated_dt': 'Вақти навсозӣ',
  'entities.providerContextClassifier.title': 'Синфкунандаи контексти таъминкунанда',
  'entities.resultContextClassifier.fields.context_pipeline': 'Нақбаи контекст',
  'entities.resultContextClassifier.fields.created_dt': 'Вақти эҷод',
  'entities.resultContextClassifier.fields.data_pipeline': 'Нақби маълумот',
  'entities.resultContextClassifier.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.resultContextClassifier.fields.id': 'Рақам / ID',
  'entities.resultContextClassifier.fields.storage_data': 'Маълумоти захира',
  'entities.resultContextClassifier.fields.updated_dt': 'Вақти навсозӣ',
  'entities.resultContextClassifier.title': 'Натиҷа — синфкунанда',
  'entities.resultScheduler.fields.created_dt': 'Вақти эҷод',
  'entities.resultScheduler.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.resultScheduler.fields.detail_scheduler': 'Тафсилоти ҷадвалгузор',
  'entities.resultScheduler.fields.history_running_pipeline': 'Сабти иҷрои нақб',
  'entities.resultScheduler.fields.history_running_pipeline_id': 'Рақами таърихи иҷро',
  'entities.resultScheduler.fields.id': 'Рақам / ID',
  'entities.resultScheduler.fields.updated_dt': 'Вақти навсозӣ',
  'entities.resultScheduler.title': 'Натиҷаи ҷадвал',
  'entities.role.fields.created_dt': 'Вақти эҷод',
  'entities.role.fields.id': 'Рақам / ID',
  'entities.role.fields.name': 'Ном',
  'entities.role.fields.slug': 'Нишона (slug)',
  'entities.role.fields.updated_dt': 'Вақти навсозӣ',
  'entities.role.title': 'Нақш',
  'entities.running.fields.created_dt': 'Вақти эҷод',
  'entities.running.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.running.fields.id': 'Рақам / ID',
  'entities.running.fields.name': 'Ном',
  'entities.running.fields.slug': 'Нишона (slug)',
  'entities.running.fields.updated_dt': 'Вақти навсозӣ',
  'entities.running.title': 'Намуди иҷро',
  'entities.scheduler.fields.created_dt': 'Вақти эҷод',
  'entities.scheduler.fields.data_pipeline': 'Нақби маълумот',
  'entities.scheduler.fields.data_pipeline_id': 'Рақами нақби маълумот',
  'entities.scheduler.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.scheduler.fields.id': 'Рақам / ID',
  'entities.scheduler.fields.name': 'Ном',
  'entities.scheduler.fields.pipeline': 'Нақб',
  'entities.scheduler.fields.pipeline_id': 'Рақами нақб',
  'entities.scheduler.fields.updated_dt': 'Вақти навсозӣ',
  'entities.scheduler.title': 'Ҷадвалгузор',
  'entities.schemaPipeline.fields.broker_event': 'Рӯйдади брокер',
  'entities.schemaPipeline.fields.broker_event_id': 'Рӯйдади брокер (ID)',
  'entities.schemaPipeline.fields.created_dt': 'Вақти эҷод',
  'entities.schemaPipeline.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.schemaPipeline.fields.id': 'Рақам / ID',
  'entities.schemaPipeline.fields.name': 'Ном',
  'entities.schemaPipeline.fields.pipeline': 'Нақб',
  'entities.schemaPipeline.fields.service': 'Хизматрасонӣ',
  'entities.schemaPipeline.fields.service_id': 'Рақами хизматрасонӣ',
  'entities.schemaPipeline.fields.type_event': 'Намуди рӯйдод',
  'entities.schemaPipeline.fields.type_event_id': 'Рақами намуди рӯйдод',
  'entities.schemaPipeline.fields.type_exit_event_id': 'Намуди рӯйдади баромад',
  'entities.schemaPipeline.fields.type_running': 'Намуди иҷро',
  'entities.schemaPipeline.fields.type_running_id': 'Рақами намуди иҷро',
  'entities.schemaPipeline.fields.type_stream_event_id': 'Намуди рӯйдади ҷараён',
  'entities.schemaPipeline.fields.updated_dt': 'Вақти навсозӣ',
  'entities.schemaPipeline.fields.version': 'Насх',
  'entities.schemaPipeline.fields.version_id': 'Рақами насх',
  'entities.schemaPipeline.title': 'Схемаи нақб',
  'entities.service.fields.created_dt': 'Вақти эҷод',
  'entities.service.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.service.fields.id': 'Рақам / ID',
  'entities.service.fields.name': 'Ном',
  'entities.service.fields.organization': 'Ташкилот',
  'entities.service.fields.organization_id': 'Рақами субъект',
  'entities.service.fields.slug': 'Нишона (slug)',
  'entities.service.fields.type_service': 'Намуди хизматрасонӣ',
  'entities.service.fields.type_service_id': 'Рақами намуди хизматрасонӣ',
  'entities.service.fields.updated_dt': 'Вақти навсозӣ',
  'entities.service.title': 'Хизматрасонӣ',
  'entities.serviceBuild.fields.build_dt': 'Вақти ҷамъоварӣ',
  'entities.serviceBuild.fields.build_id': 'Рақами ҷамъоварӣ',
  'entities.serviceBuild.fields.service_id': 'Рақами хизматрасонӣ',
  'entities.serviceBuild.fields.status': 'Ҳолат',
  'entities.serviceBuild.fields.version_id': 'Рақами насх',
  'entities.serviceBuild.title': 'Service Build',
  'entities.serviceEvent.fields.created_dt': 'Вақти эҷод',
  'entities.serviceEvent.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.serviceEvent.fields.id': 'Рақам / ID',
  'entities.serviceEvent.fields.name': 'Ном',
  'entities.serviceEvent.fields.organization': 'Ташкилот',
  'entities.serviceEvent.fields.organization_id': 'Рақами субъект',
  'entities.serviceEvent.fields.slug': 'Нишона (slug)',
  'entities.serviceEvent.fields.type_service': 'Намуди хизматрасонӣ',
  'entities.serviceEvent.fields.type_service_id': 'Рақами намуди хизматрасонӣ',
  'entities.serviceEvent.fields.updated_dt': 'Вақти навсозӣ',
  'entities.serviceEvent.title': 'Рӯйдади хизматрасонӣ',
  'entities.serviceParams.fields.created_dt': 'Вақти эҷод',
  'entities.serviceParams.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.serviceParams.fields.details': 'Тафсилот (JSON)',
  'entities.serviceParams.fields.details_id': 'Рақами намуднамои параметрҳо',
  'entities.serviceParams.fields.id': 'Рақам / ID',
  'entities.serviceParams.fields.name': 'Ном',
  'entities.serviceParams.fields.organization': 'Ташкилот',
  'entities.serviceParams.fields.organization_id': 'Рақами субъект',
  'entities.serviceParams.fields.slug': 'Нишона (slug)',
  'entities.serviceParams.fields.type_service': 'Намуди хизматрасонӣ',
  'entities.serviceParams.fields.type_service_id': 'Рақами намуди хизматрасонӣ',
  'entities.serviceParams.fields.updated_dt': 'Вақти навсозӣ',
  'entities.serviceParams.title': 'Параметрҳои хизматрасонӣ',
  'entities.serviceRun.fields.run_dt': 'Вақти оғоз',
  'entities.serviceRun.fields.run_id': 'Рақами иҷро',
  'entities.serviceRun.fields.service_id': 'Рақами хизматрасонӣ',
  'entities.serviceRun.fields.status_id': 'Рақами ҳолат',
  'entities.serviceRun.title': 'Service Run',
  'entities.serviceType.fields.created_dt': 'Вақти эҷод',
  'entities.serviceType.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.serviceType.fields.id': 'Рақам / ID',
  'entities.serviceType.fields.name': 'Ном',
  'entities.serviceType.fields.slug': 'Нишона (slug)',
  'entities.serviceType.fields.updated_dt': 'Вақти навсозӣ',
  'entities.serviceType.title': 'Намуди хизматрасонӣ',
  'entities.serviceVersion.fields.cache': 'Кеш',
  'entities.serviceVersion.fields.code': 'Рамз',
  'entities.serviceVersion.fields.created_dt': 'Вақти эҷод',
  'entities.serviceVersion.fields.default': 'Пешфарз',
  'entities.serviceVersion.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.serviceVersion.fields.id': 'Рақам / ID',
  'entities.serviceVersion.fields.input_type_params': 'Намуди параметрҳои вуруд',
  'entities.serviceVersion.fields.name': 'Ном',
  'entities.serviceVersion.fields.npp': 'Рақами тартиб',
  'entities.serviceVersion.fields.output_type_params': 'Намуди параметрҳои берун',
  'entities.serviceVersion.fields.service': 'Хизматрасонӣ',
  'entities.serviceVersion.fields.stream_type_params': 'Намуди параметрҳои ҷараён',
  'entities.serviceVersion.fields.updated_dt': 'Вақти навсозӣ',
  'entities.serviceVersion.title': 'Насхи хизматрасонӣ',
  'entities.serviceVersionBuild.fields.build_dt': 'Вақти ҷамъоварӣ',
  'entities.serviceVersionBuild.fields.build_id': 'Рақами ҷамъоварӣ',
  'entities.serviceVersionBuild.fields.service_id': 'Рақами хизматрасонӣ',
  'entities.serviceVersionBuild.fields.status': 'Ҳолат',
  'entities.serviceVersionBuild.title': 'Service Version Build',
  'entities.serviceVersionRun.fields.run_dt': 'Вақти оғоз',
  'entities.serviceVersionRun.fields.run_id': 'Рақами иҷро',
  'entities.serviceVersionRun.fields.service_id': 'Рақами хизматрасонӣ',
  'entities.serviceVersionRun.fields.status': 'Ҳолат',
  'entities.serviceVersionRun.title': 'Service Version Run',
  'entities.shareContextStorage.fields.created_dt': 'Вақти эҷод',
  'entities.shareContextStorage.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.shareContextStorage.fields.id': 'Рақам / ID',
  'entities.shareContextStorage.fields.organization': 'Ташкилот',
  'entities.shareContextStorage.fields.organization_id': 'Рақами субъект',
  'entities.shareContextStorage.fields.provider': 'Таъминкунанда',
  'entities.shareContextStorage.fields.storage': 'Захира',
  'entities.shareContextStorage.fields.storage_id': 'Рақами захира',
  'entities.shareContextStorage.fields.updated_dt': 'Вақти навсозӣ',
  'entities.shareContextStorage.title': 'Захираи умумии контекст',
  'entities.subject.fields.create_user_id': 'Рақами корбари созмонкунанда',
  'entities.subject.fields.created_dt': 'Вақти эҷод',
  'entities.subject.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.subject.fields.id': 'Рақам / ID',
  'entities.subject.fields.name': 'Ном',
  'entities.subject.fields.parent_id': 'Рақами волидайнӣ',
  'entities.subject.fields.type': 'Намуд',
  'entities.subject.fields.updated_dt': 'Вақти навсозӣ',
  'entities.subject.title': 'Субъект',
  'entities.subjectType.fields.created_dt': 'Вақти эҷод',
  'entities.subjectType.fields.name': 'Ном',
  'entities.subjectType.fields.slug': 'Нишона (slug)',
  'entities.subjectType.fields.subjectTypeId': 'Рақами намуди субъект',
  'entities.subjectType.fields.updated_dt': 'Вақти навсозӣ',
  'entities.subjectType.title': 'Намуди субъект',
  'entities.testPipeline.fields.created_dt': 'Вақти эҷод',
  'entities.testPipeline.fields.data_pipeline': 'Нақби маълумот',
  'entities.testPipeline.fields.data_pipeline_id': 'Рақами нақби маълумот',
  'entities.testPipeline.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.testPipeline.fields.distance_service': 'Хизматрасонии масофа',
  'entities.testPipeline.fields.distance_service_id': 'Рақами хизматрасонии масофа',
  'entities.testPipeline.fields.distance_version_service': 'Насхи хизматрасонии масофа',
  'entities.testPipeline.fields.distance_version_service_id': 'Рақами насхи хизматрасонии масофа',
  'entities.testPipeline.fields.exit_dt': 'Вақти анҷом',
  'entities.testPipeline.fields.id': 'Рақам / ID',
  'entities.testPipeline.fields.is_stopped': 'Истифода нашуда',
  'entities.testPipeline.fields.name': 'Ном',
  'entities.testPipeline.fields.run_dt': 'Вақти оғоз',
  'entities.testPipeline.fields.status': 'Ҳолат',
  'entities.testPipeline.fields.updated_dt': 'Вақти навсозӣ',
  'entities.testPipeline.title': 'Нақби санҷиш',
  'entities.testResultPipeline.fields.created_dt': 'Вақти эҷод',
  'entities.testResultPipeline.fields.data_detail_pipeline': 'Тафсилоти нақби маълумот',
  'entities.testResultPipeline.fields.data_detail_pipeline_id': 'Рақами тафсилоти маълумот',
  'entities.testResultPipeline.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.testResultPipeline.fields.distance': 'Ченаки масофа',
  'entities.testResultPipeline.fields.history_running_pipeline': 'Сабти иҷрои нақб',
  'entities.testResultPipeline.fields.history_running_pipeline_id': 'Рақами таърихи иҷро',
  'entities.testResultPipeline.fields.id': 'Рақам / ID',
  'entities.testResultPipeline.fields.test': 'Санҷиш',
  'entities.testResultPipeline.fields.updated_dt': 'Вақти навсозӣ',
  'entities.testResultPipeline.title': 'Натиҷаи санҷиш',
  'entities.tuneModel.fields.created_dt': 'Вақти эҷод',
  'entities.tuneModel.fields.data_pipeline': 'Нақби маълумот',
  'entities.tuneModel.fields.data_pipeline_id': 'Рақами нақби маълумот',
  'entities.tuneModel.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.tuneModel.fields.distance_service': 'Хизматрасонии масофа',
  'entities.tuneModel.fields.distance_service_id': 'Рақами хизматрасонии масофа',
  'entities.tuneModel.fields.distance_version_service': 'Насхи хизматрасонии масофа',
  'entities.tuneModel.fields.distance_version_service_id': 'Рақами насхи хизматрасонии масофа',
  'entities.tuneModel.fields.exit_dt': 'Вақти анҷом',
  'entities.tuneModel.fields.id': 'Рақам / ID',
  'entities.tuneModel.fields.model': 'Модел',
  'entities.tuneModel.fields.model_id': 'Рақами модел',
  'entities.tuneModel.fields.name': 'Ном',
  'entities.tuneModel.fields.run_dt': 'Вақти оғоз',
  'entities.tuneModel.fields.status': 'Ҳолат',
  'entities.tuneModel.fields.stopped': 'Қатъ шудааст',
  'entities.tuneModel.fields.updated_dt': 'Вақти навсозӣ',
  'entities.tuneModel.title': 'Вазифаи қайчӣ',
  'entities.tuneModelResult.fields.created_dt': 'Вақти эҷод',
  'entities.tuneModelResult.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.tuneModelResult.fields.history_running_pipeline': 'Сабти иҷрои нақб',
  'entities.tuneModelResult.fields.history_running_pipeline_id': 'Рақами таърихи иҷро',
  'entities.tuneModelResult.fields.id': 'Рақам / ID',
  'entities.tuneModelResult.fields.model': 'Модел',
  'entities.tuneModelResult.fields.model_id': 'Рақами модел',
  'entities.tuneModelResult.fields.tuning': 'Қайчии модел',
  'entities.tuneModelResult.fields.updated_dt': 'Вақти навсозӣ',
  'entities.tuneModelResult.title': 'Натиҷаи қайчии модел',
  'entities.typeProviderContext.fields.created_dt': 'Вақти эҷод',
  'entities.typeProviderContext.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.typeProviderContext.fields.id': 'Рақам / ID',
  'entities.typeProviderContext.fields.name': 'Ном',
  'entities.typeProviderContext.fields.organization': 'Ташкилот',
  'entities.typeProviderContext.fields.organization_id': 'Рақами субъект',
  'entities.typeProviderContext.fields.slug': 'Нишона (slug)',
  'entities.typeProviderContext.fields.updated_dt': 'Вақти навсозӣ',
  'entities.typeProviderContext.title': 'Намуди контексти таъминкунанда',
  'entities.typeSubjectCommunication.fields.created_dt': 'Вақти эҷод',
  'entities.typeSubjectCommunication.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.typeSubjectCommunication.fields.id': 'Рақам / ID',
  'entities.typeSubjectCommunication.fields.name': 'Ном',
  'entities.typeSubjectCommunication.fields.organization': 'Ташкилот',
  'entities.typeSubjectCommunication.fields.organization_id': 'Рақами субъект',
  'entities.typeSubjectCommunication.fields.slug': 'Нишона (slug)',
  'entities.typeSubjectCommunication.fields.updated_dt': 'Вақти навсозӣ',
  'entities.typeSubjectCommunication.title': 'Намуди субъекти коммуникатсия',
  'entities.user.fields.created_dt': 'Вақти эҷод',
  'entities.user.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.user.fields.email': 'Почтаи электронӣ',
  'entities.user.fields.id': 'Рақам / ID',
  'entities.user.fields.is_active': 'Фаъол',
  'entities.user.fields.login': 'Логин (почта)',
  'entities.user.fields.name': 'Ном',
  'entities.user.fields.parent_id': 'Рақами волидайнӣ',
  'entities.user.fields.password': 'Парол',
  'entities.user.fields.role': 'Нақш',
  'entities.user.fields.updated_dt': 'Вақти навсозӣ',
  'entities.user.fields.user_id': 'Рақами корбар',
  'entities.user.title': 'Корбар',
  'entities.userContext.fields.current_user_id': 'Корбари ҷорӣ',
  'entities.userContext.fields.org_structure_id': 'Рақами сохтор',
  'entities.userContext.fields.org_structure_name': 'Номи сохтор',
  'entities.userContext.fields.organization_id': 'Рақами субъект',
  'entities.userContext.fields.organization_name': 'Номи ташкилот',
  'entities.userContext.fields.parent_user_id': 'Корбари волидайнӣ',
  'entities.userContext.title': 'Контексти корбар',
  'entities.userOrganizationStructure.fields.access_token': 'Нишонаи дастрасӣ',
  'entities.userOrganizationStructure.fields.access_token_expired_time': 'Хотимаи мӯҳлати токени дастрасӣ',
  'entities.userOrganizationStructure.fields.created_dt': 'Вақти эҷод',
  'entities.userOrganizationStructure.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.userOrganizationStructure.fields.id': 'Рақам / ID',
  'entities.userOrganizationStructure.fields.org_structure': 'Сохтори созмонӣ',
  'entities.userOrganizationStructure.fields.org_structure_id': 'Рақами сохтор',
  'entities.userOrganizationStructure.fields.organization': 'Ташкилот',
  'entities.userOrganizationStructure.fields.organization_id': 'Рақами субъект',
  'entities.userOrganizationStructure.fields.refresh_token': 'Нишонаи навкунӣ',
  'entities.userOrganizationStructure.fields.refresh_token_expired_time': 'Хотимаи мӯҳлати нишонаи навкунӣ',
  'entities.userOrganizationStructure.fields.updated_dt': 'Вақти навсозӣ',
  'entities.userOrganizationStructure.fields.user_id': 'Рақами корбар',
  'entities.userOrganizationStructure.title': 'Корбар дар сохтор',
  'entities.versionProviderContext.fields.created_dt': 'Вақти эҷод',
  'entities.versionProviderContext.fields.data': 'Маълумот',
  'entities.versionProviderContext.fields.default': 'Пешфарз',
  'entities.versionProviderContext.fields.deleted_dt': 'Вақти несткунӣ',
  'entities.versionProviderContext.fields.id': 'Рақам / ID',
  'entities.versionProviderContext.fields.limit': 'Ҳудуд',
  'entities.versionProviderContext.fields.name': 'Ном',
  'entities.versionProviderContext.fields.npp': 'Рақами тартиб',
  'entities.versionProviderContext.fields.provider': 'Таъминкунанда',
  'entities.versionProviderContext.fields.updated_dt': 'Вақти навсозӣ',
  'entities.versionProviderContext.fields.version': 'Насх',
  'entities.versionProviderContext.fields.version_id': 'Рақами насх',
  'entities.versionProviderContext.title': 'Насхи контексти таъминкунанда',
};
